import type { DocumentFlagProjection, Flag, User } from '~/shared/api/data-ingestion-api/client'

import { getFlagCreator } from './flag-comments'
import { getPendingFlags } from './get-pending-flags'

function isFlag(flag: Flag | DocumentFlagProjection): flag is Flag {
  return 'flag_status' in flag
}

export function getFlagAuthors(flags: (Flag | DocumentFlagProjection)[]): User[] {
  const pending = getPendingFlags(flags)
  const seen = new Set<string>()
  const authors: User[] = []

  for (const flag of pending) {
    const author = isFlag(flag) ? getFlagCreator(flag)?.user : flag.last_commented_by
    if (!author) continue
    if (!seen.has(author.sub)) {
      seen.add(author.sub)
      authors.push(author)
    }
  }

  return authors
}
